"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Bghost = void 0;
/**
 * Background task host
 *
 * Provides a mechanism to "cancel" asynchronous tasks.
 *
 * @package HOPS
 * @subpackage App
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */
class Bghost {
  /**
   * Key used for invalidation
   */
  key = 1;

  /**
   * Wait for a Promise to resolve.
   *
   * Returns a new Promise whose handlers are only invoked when 
   * we haven't invalidated the cache during the operation.
   *
   * @param {Promise} promise
   * @return {Promise}
   */
  exec(promise) {
    const key = this.key;
    const handleResult = (handler, handlerRejection, data) => {
      return key === this.key ? handler(data) : handlerRejection();
    };
    return new Promise((resolve, reject) => {
      promise.then(data => {
        return handleResult(resolve, reject, data);
      }).catch(e => {
        return handleResult(reject, reject, e);
      });
    });
  }

  /**
   * Invalidate any currently executing tasks.
   *
   * Increments our task invalidation key.
   * 
   * @return {void}
   */
  invalidate() {
    this.key++;
  }
}
exports.Bghost = Bghost;
var _default = exports.default = new Bghost();